import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function NoRecords(props: any) {
  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      style={{ height: "100%" }}
    >
      <Typography fontWeight={"bold"} fontStyle={"italic"} color={"primary"}>
        No Records Found
      </Typography>
    </Grid>
  );
}
